module.exports = __webpack_public_path__ + "0fce314d66535adfa460eb4d1b635c99.svg";